import { useCallback, useState } from "react";
import { useEventListener } from "./useEventListener";
import { Nil } from "cy-util";

/**
 * Detects if an element is hovered with mouse.
 * @param ele
 */
export function useHover(ele: HTMLElement | Nil) {
  const [hover, setHover] = useState(false);
  const onHover = useCallback(() => setHover(true), []);
  const offHover = useCallback(() => setHover(false), []);
  useEventListener("mouseenter", onHover, ele || undefined);
  useEventListener("mouseleave", offHover, ele || undefined);
  return hover;
}
